// extracted by extract-css-chunks-webpack-plugin
module.exports = {"vFeed":"vFeed-DEnF1f8M","vComment":"vComment-13DARC_0","vDingCai":"vDingCai-26tP8pYw","vDing":"vDing-2l2sgjLS"};